import { Pipe, PipeTransform } from '@angular/core';
import { Company } from '~gc/domains/users/companies/company.model';
import { User } from '../../domains/users';

@Pipe({
  name: 'companyLogo'
})
export class CompanyLogoPipe implements PipeTransform {
  transform(user: (User & { companyId?: string }) | null | undefined, companies: Company[]): string {
    console.log(user)
    console.log(companies)
    if (!user || !user.companyId || !companies?.length) {
      return '/assets/images/logo.svg';
    }

    const company = companies.find(c => c.id === user.companyId);
    if (!company) {
      return '/assets/images/logo.svg';
    }

    if (company.logoUrl) return company.logoUrl;

    if (company.logo?.data) {
      const byteArray = new Uint8Array(company.logo.data);
      const blob = new Blob([byteArray], { type: company.logo.type || 'image/png' });
      return URL.createObjectURL(blob);
    }

    return '/assets/images/logo.svg';
  }
}